import { Flex, IconV2, TextV2 } from '@withjoy/joykit';
import type { FC } from 'react';
import React from 'react';
import { styles } from './EventPreview.styles';

type IconCardProps = Readonly<{
  icon: React.ReactNode;
  text: string;
  onClick(): void;
}>;

export const IconCard: FC<IconCardProps> = ({ icon, text, onClick }) => (
  <Flex
    as="button"
    onClick={onClick}
    __css={styles.iconCard}
  >
    <IconV2 size="xxl">{icon}</IconV2>
    <TextV2 typographyVariant="button2">{text}</TextV2>
  </Flex>
);
